var _path, _path2, _path3, _path4, _rect, _path5, _circle, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnCorrectPalm4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 111,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.424 79.086c.85 17.745 15.372 31.911 33.105 31.911 17.733 0 32.255-14.172 33.104-31.911H.424z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.885 77.567V41.836c0-2.658-2.06-4.538-5.007-4.586-2.47-.048-4.724.886-6.562 2.688a9.95 9.95 0 0 0-1.139 1.313V14.136c0-4.332-3.537-7.875-7.893-7.875a7.77 7.77 0 0 0-4.833 1.663v-.049C41.451 3.543 37.914 0 33.558 0c-4.357 0-7.894 3.525-7.894 7.875v.049a7.82 7.82 0 0 0-4.832-1.663c-4.345 0-7.894 3.525-7.894 7.875v9.014a7.82 7.82 0 0 0-4.832-1.663c-4.345 0-7.894 3.525-7.894 7.876L.64 79.652h66.245v-2.085z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.301 29.363c0-2.658 2.17-4.82 4.833-4.82 2.663 0 4.832 2.162 4.832 4.82v23.084c0 .837.681 1.518 1.525 1.518.844 0 1.524-.68 1.524-1.518v-38.33c0-2.656 2.17-4.82 4.833-4.82 2.663 0 4.832 2.164 4.832 4.82V52.43c0 .837.681 1.518 1.525 1.518.843 0 1.524-.681 1.524-1.519V7.876c0-2.657 2.17-4.82 4.833-4.82 2.663 0 4.832 2.163 4.832 4.82v44.566c0 .837.681 1.518 1.525 1.518.843 0 1.524-.68 1.524-1.519V14.136c0-2.657 2.17-4.82 4.833-4.82 2.663 0 4.832 2.163 4.832 4.82v35.635c0 .097.018.187.03.283-.018.314-.03.633-.03.934V67.51c0 .838.681 1.519 1.525 1.519.843 0 1.524-.681 1.524-1.519V50.97c0-3.428 1.284-6.911 3.284-8.87 1.253-1.235 2.724-1.831 4.375-1.801.759.018 2.012.235 2.012 1.537v21.836c0 .157.03.302.079.44l-.079.018v14.944h3.061V41.836c0-2.658-2.06-4.538-5.007-4.586-2.47-.048-4.724.886-6.562 2.688a9.95 9.95 0 0 0-1.139 1.313V14.136c0-4.332-3.537-7.875-7.893-7.875a7.77 7.77 0 0 0-4.833 1.663v-.049C41.455 3.543 37.918 0 33.562 0c-4.357 0-7.894 3.525-7.894 7.875v.049a7.82 7.82 0 0 0-4.832-1.663c-4.345 0-7.894 3.525-7.894 7.875v9.014a7.82 7.82 0 0 0-4.832-1.663c-4.345 0-7.894 3.525-7.894 7.876l.12 49.71h2.99v-49.71H3.3z",
    fill: "#DEE5F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.545 107.92c-16.064 0-29.333-12.823-30.188-28.858H.332C1.182 96.808 15.812 111 33.545 111s32.532-14.197 33.382-31.936h-3.043c-.837 16.052-14.275 28.857-30.339 28.857z",
    fill: "#DEE5F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.207,
    y: 14.375,
    width: 48.755,
    height: 81.964,
    rx: 6,
    stroke: "#9BACD7",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.207 87.508h48.755v2.832a6 6 0 0 1-6 6H14.207a6 6 0 0 1-6-6v-2.832zM8.207 18.968a4.593 4.593 0 0 1 4.593-4.593h39.569a4.593 4.593 0 0 1 4.593 4.593H8.207z",
    fill: "#9BACD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.408,
    cy: 92.454,
    r: 2.473,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5758",
    d: "m44.629 78.916 3.366-3.653L64.43 90.408l-3.366 3.653z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5758",
    d: "m60.676 75.006 3.512 3.512-15.803 15.803-3.512-3.512z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCorrectPalm4);
export default __webpack_public_path__ + "static/media/un-correct-palm-4.01b4a3bcb1015a99f6fee8e05fd95f44.svg";
export { ForwardRef as ReactComponent };